import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { AdminDecisionServiceDTO } from '../models/admin-decision-DTO.model';
import { UserResponseDto } from '../models/adminResponseDto';

@Injectable({
  providedIn: 'root'
})
export class AdminDecisionService {

  constructor(private http:HttpServices) { }

  addAdminDecision(adminDecisionDTO: AdminDecisionServiceDTO) {

    return this.http.post('AdminDecision/AddAdminDecision/', adminDecisionDTO);
  }

  getAdminDecision(id){
    return this.http.get('AdminDecision/GetAdminDecision/'+id);
  }

  setUserResponse(userResponse:UserResponseDto){
    return this.http.post('AdminDecision/setUserResponse/',userResponse);
  }
}
